import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

const BankAccountsFilter = (props) => {
  const { bankAccountId, bankAccountsInfo, onChange } = props;

  return (
    <div className="input">
      <select
        id="bankAccountEq"
        defaultValue={bankAccountId}
        onChange={onChange}
      >
        <option value=""> -- select a bank account -- </option>
        {bankAccountsInfo?.map((bankAccountInfo) => (
          <option
            value={bankAccountInfo.id}
            key={bankAccountInfo.id}
          >{`${bankAccountInfo.name} || ${bankAccountInfo.institutionName} || (${bankAccountInfo.plaidAccountId})`}</option>
        ))}
      </select>
    </div>
  );
};

export default BankAccountsFilter;

BankAccountsFilter.propTypes = {
  bankAccountsInfo: PropTypes.arrayOf(PropTypes.shape().isRequired),
  bankAccountId: PropTypes.string,
  onChange: PropTypes.func,
};

BankAccountsFilter.defaultProps = {
  bankAccountsInfo: null,
  bankAccountId: '',
  onChange: noop,
};
